
import Vue from 'vue';
import ListItem from '@/components/base/ListItem.vue';

export default Vue.extend({
	name: 'BorderSelectCard',
	props: {
		value: { type: Boolean, required: true },
		icon: { type: String, default: null },
		disabled: { type: Boolean, default: false },
		containerStyles: { type: Object, default: () => {} },
		small: { type: Boolean, default: false },
	},
	methods: {
		onSelect () {
			if (!this.disabled) {
				this.$emit('on-click');
			}
		},
	},
	components: {
		ListItem,
	},
});
